<template>
  <div class="app-modal-custom-wrapper">
    <slot />
  </div>
</template>

<!-- eslint-disable-next-line vue/enforce-style-attribute -->
<style lang="scss">
.app-modal-custom-wrapper {
  padding: 0 32px;
}
</style>
